import { Content } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import classNames from 'classnames';
import styles from 'components/PRISMIC/scss/pages.module.scss';

import type { JSX } from 'react';

/**
 * Props for `List`.
 */
export type ListProps = SliceComponentProps<Content.ListSlice>;

/**
 * Component for "List" Slices.
 */
const List = ({ slice }: ListProps): JSX.Element => {
  const isOrdered = slice.primary.liststyle === 'ordered';
  const ListComponent = isOrdered ? OrderedList : UnorderedList;

  return (
    <ListComponent
      className={classNames(
        isOrdered ? 'list-decimal' : 'list-disc',
        styles.pl
      )}
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {slice.items.map((it, i) => (
        <PrismicRichText
          key={i}
          field={it.item}
          components={{
            paragraph: ({ children }) => (
              <li className={styles.copy} key={i}>
                {children}
              </li>
            )
          }}
        />
      ))}
    </ListComponent>
  );
};

const UnorderedList = (props: React.HTMLAttributes<HTMLUListElement>) => (
  <ul {...props} />
);

const OrderedList = (props: React.HTMLAttributes<HTMLUListElement>) => (
  <ol {...props} />
);

export default List;
